<template>
  <div class="components__progress-tile-bar">
    <div v-if="progress && progress.boxes" class="boxes">
      <div
        v-for="(box, index) in progress.boxes"
        v-bind:key="index"
        class="box"
        v-bind:class="{inverted: box.inverted}"
        v-bind:title="boxTitle(box, progress.boxes)"
        v-bind:style="{'background-color': box.color, flex: flexValue(box, progress.boxes)}"
      >
        <template
          v-if="showBoxValue(box, progress.boxes)"
        >{{boxDisplayedValue(box, progress.boxes)}}</template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~stylesheets/frontend/variables/colors";

.components__progress-tile-bar {
  .boxes {
    margin-top: 9px;

    display: flex;
    .box {
      height: 22px;
      text-align: center;
      color: $color-default;
      font-size: 14px;
      line-height: 22px;

      cursor: default;

      &.inverted {
        color: $color-white;
      }
    }
  }
}
</style>

<script lang="ts" setup>

  const props = defineProps({
    progress: {
      type: Object,
      default: null,
    },
    displayAbsoluteValues: {
      type: Boolean,
      default: false,
    },
  });

  const flexValue = (box: any, boxes: any) => {
    return Math.round((box.total / getTotal(boxes)) * 100) / 100;
  };
  const showBoxValue = (box: any, boxes: any) => {
    return box.total / getTotal(boxes) > 0.1;
  }
  const boxTitle = (box: any, boxes: any) => {
    return `${box.label}: ${boxDisplayedValue(box, boxes)}`;
  };
  const boxDisplayedValue = (box: any, boxes: any) => {
    if (props.displayAbsoluteValues) {
      return box.total;
    }
    return Math.round((box.total * 100) / getTotal(boxes)) + "%";
  };
  const getTotal = (boxes: any) => {
    let total = 0;
    if (boxes) {
      for (const box of boxes) {
        total += box.total;
      }
    }

    if (total === 0) {
      // mitigate division by zero
      return 1;
    }
    return total;
  };
</script>
